import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {LicenseType} from '../../../../model/license/license-type';

export type Props = {
  isDrawerOpen: boolean
  onDrawerClosed: () => void
  createOrganizationLicense: (licenseType: string, licenseExpiredDate: string, discount: number) => Promise<void>
}

export type CreateOrganizationLicenseDrawerState = {
  licenseTypes: LicenseType[]
  selectedLicenseType: string | null,
  setSelectedLicenseType: (value: string | null) => void
  discount: string,
  setDiscount: (value: string) => void
  expiredDate: string | null,
  setExpiredDate: (value: string | null) => void

  closeDrawer: () => void
  handleSubmit: () => Promise<void>
  saveButtonDisabled: boolean

  translateLocal: (key: string) => string
  translate: (key: string) => string
}

export const useCreateOrganizationLicenseDrawerState = (props: Props): CreateOrganizationLicenseDrawerState => {
  const {t} = useTranslation()
  const [selectedLicenseType, setSelectedLicenseType] = useState<string | null>(null);
  const [discount, setDiscount] = useState<string>('0');
  const [expiredDate, setExpiredDate] = useState<string | null>(null);

  const closeDrawer = () => {
    setSelectedLicenseType(null);
    setDiscount('0');
    setExpiredDate(null);

    props.onDrawerClosed();
  }

  const handleSubmit = async () => {
    await props.createOrganizationLicense(
      selectedLicenseType as string,
      expiredDate as string,
      discount === '' ? 0 : parseFloat(discount)
    )
    closeDrawer()
  }

  return {
    translate: (key) => t(key),
    translateLocal: (key) => t(`organizations-page.create-organization-license-drawer.${key}`),
    licenseTypes: Object.values(LicenseType),
    selectedLicenseType: selectedLicenseType,
    setSelectedLicenseType: setSelectedLicenseType,
    discount: discount,
    setDiscount: setDiscount,
    expiredDate: expiredDate,
    setExpiredDate: setExpiredDate,
    closeDrawer: closeDrawer,
    handleSubmit: handleSubmit,
    saveButtonDisabled: selectedLicenseType === null || selectedLicenseType === ''
      || expiredDate === null || expiredDate === ''
  }
}
